import { DialogContent, DialogContentText } from "@mui/material";
import React from "react";

const DialogEstablishmentContent = ({ selectedEstablishment }) => {
    return (
        <DialogContent>
            <DialogContentText>
                <strong>Dirección:</strong> {selectedEstablishment.address}
            </DialogContentText>
            <DialogContentText>
                <strong>Email:</strong> {selectedEstablishment.email}
            </DialogContentText>
            <DialogContentText>
                <strong>Teléfono:</strong> {selectedEstablishment.phone}
            </DialogContentText>
            <DialogContentText>
                <strong>Cueanexo:</strong> {selectedEstablishment.cueanexo}
            </DialogContentText>
            <DialogContentText>
                <strong>Provincia:</strong> {selectedEstablishment.province}
            </DialogContentText>
            <DialogContentText>
                <strong>Localidad:</strong> {selectedEstablishment.location}
            </DialogContentText>
            <DialogContentText>
                <strong>Ambito:</strong> {selectedEstablishment.ambit}
            </DialogContentText>
        </DialogContent>
    );
};

export default DialogEstablishmentContent;
